__turbopack_context__.v({
  "appCard": "page-module__LGNMsG__appCard",
  "appCardBody": "page-module__LGNMsG__appCardBody",
  "appCardDesc": "page-module__LGNMsG__appCardDesc",
  "appCardMedia": "page-module__LGNMsG__appCardMedia",
  "appCardOverlay": "page-module__LGNMsG__appCardOverlay",
  "appCardOverlayLogo": "page-module__LGNMsG__appCardOverlayLogo",
  "appCardTitle": "page-module__LGNMsG__appCardTitle",
  "applicationsNoticeLine": "page-module__LGNMsG__applicationsNoticeLine",
  "applicationsNotices": "page-module__LGNMsG__applicationsNotices",
  "applicationsPage": "page-module__LGNMsG__applicationsPage",
  "applicationsTitle": "page-module__LGNMsG__applicationsTitle",
  "appsGrid": "page-module__LGNMsG__appsGrid",
  "noResults": "page-module__LGNMsG__noResults",
  "searchIcon": "page-module__LGNMsG__searchIcon",
  "searchInput": "page-module__LGNMsG__searchInput",
  "searchWrap": "page-module__LGNMsG__searchWrap",
});
